import React from 'react';

import EllipsisAnimation from '../../EllipsisAnimation/EllipsisAnimation';
import styles from './ButtonSecondary.module.scss';

interface IButtonSecondaryProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  href?: string;
  isActive?: boolean;
  onClick?: (e: any) => void | Promise<void> ;
  rel?: string;
  target?: string;
  title?: string;
}

const ButtonSecondary = ({
  children,
  className,
  disabled,
  href,
  isActive,
  onClick,
  rel,
  target,
  title,
}:IButtonSecondaryProps) => {
  if (href) {
    return (
      <a
        className={ `
          ${styles.ButtonSecondary}
          ${className}
          ${isActive ? styles.isActive : ''}
          ${disabled ? styles.isDisabled : ''}
        ` }
        data-test="button-secondary"
        href={ href }
        onClick={ onClick }
        rel={rel || 'noopener nofollow noreferrer'}
        target={ target }
        title={ title }
      >
        {children}
        {isActive && (
          <EllipsisAnimation />
        )}
      </a>
    );
  }

  return (
    <button
      className={ `${styles.ButtonSecondary} ${className} ${isActive ? styles.isActive : ''}` }
      data-test="button-secondary"
      disabled={ disabled }
      onClick={ onClick }
      title={ title }
      type="button"
    >
      {children}
      {isActive && (
        <EllipsisAnimation />
      )}
    </button>
  );
};

export default ButtonSecondary;
